import { DataGrid } from '@mui/x-data-grid'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import * as React from 'react'
import { useQuery } from '@apollo/client'
import { getAllSystemConfigs } from '../../graphql/queries'
import ProgressBar from '../circularProgress/circularProgress'
import { Box, Button, Chip } from '@mui/material'
import { useState, useEffect } from 'react'

const columns = [
  {
    field: 'tableIndex',
    headerName: '#',
    flex: 0.2,
    minWidth: 150,
    filterable: false,
    sortable: false,
  },
  { field: 'provider', headerName: 'Provider', flex: 1.5 },
  { field: 'systemType', headerName: 'System Type', flex: 2 },
  { field: 'systemModel', headerName: 'System Model', flex: 2.5 },
  {
    field: 'createdAt',
    headerName: 'Created At',
    flex: 2,
    renderCell: params => new Date(params.value).toLocaleDateString(),
  },
  {
    field: 'updatedAt',
    headerName: 'Updated At',
    flex: 2,
    renderCell: params => new Date(params.value).toLocaleDateString(),
  },
]

export default function SystemTable() {
  const [searchParams, setSearchParams] = useSearchParams()
  const initialPage = parseInt(searchParams.get('page')) || 0
  const initialPageSize = parseInt(searchParams.get('pageSize')) || 50
  const [page, setPage] = useState(initialPage)
  const [pageSize, setPageSize] = useState(initialPageSize)
  const [totalCount, setTotalCount] = useState(0)

  const navigate = useNavigate()

  // URL query param güncelleme
  useEffect(() => {
    setSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
    })
  }, [page, pageSize, setSearchParams])

  const { data, loading, error } = useQuery(getAllSystemConfigs, {
    variables: {
      page: page + 1, // API 1-indexed ise
      pageSize,
    },
    fetchPolicy: 'cache-and-network',
  })

  // totalCount güncelle
  useEffect(() => {
    if (data?.getAllSystemConfigs?.totalCount) {
      setTotalCount(data.getAllSystemConfigs.totalCount)
    }
  }, [data])

  if (loading) return <ProgressBar />
  if (error) return <p>Error: {error.message}</p>

  const rowsData = data?.getAllSystemConfigs?.systemConfigs || []
  const rowsWithIndex = rowsData.map((row, index) => ({
    ...row,
    tableIndex: page * pageSize + index + 1,
  }))

  const handleRowClick = params => {
    navigate(`/system/${params.id}`)
  }

  const handlePaginationModelChange = newModel => {
    setPage(newModel.page)
    setPageSize(newModel.pageSize)
  }

  return (
    <Box style={{ width: '100%' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 2 }}>
        <h2 style={{ margin: 0, color: '#212529', fontWeight: 'bold' }}>System Configurations</h2>
        <Link to="/system/create">
          <Button
            variant="contained"
            sx={{ 
              backgroundColor: '#212529', 
              '&:hover': { backgroundColor: '#495057' },
              borderRadius: 2,
              px: 3
            }}
          >
            Create System Config
          </Button>
        </Link>
      </Box>
      <DataGrid
        rows={rowsWithIndex}
        columns={columns}
        rowHeight={80}
        disableColumnMenu
        paginationMode="server"
        page={page}
        onPageChange={newPage => setPage(newPage)}
        pageSize={pageSize}
        onPageSizeChange={newSize => {
          setPageSize(newSize)
          setPage(0)
        }}
        rowCount={totalCount}
        onRowClick={handleRowClick}
        rowsPerPageOptions={[25, 50, 100]}
        loading={loading}
        pagination
        paginationModel={{ page, pageSize }}
        onPaginationModelChange={handlePaginationModelChange}
        pageSizeOptions={[25, 50, 100]}
        sx={{
          height: 680,
          '& .MuiDataGrid-virtualScroller': {
            msOverflowY: 'auto',
          },
          fontSize: '16px',
          '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: 'bold',
          },
          '& .MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight) > .MuiDataGrid-cell': {
            whiteSpace: 'break-spaces',
          },
          '.MuiFormControl-root': {
            margin: '0px 0px 10px 0px',
            width: '100px',
          },
          '.MuiOutlinedInput-root': {
            width: '150px',
          },
          '.MuiToolbar-regular': {
            padding: 0,
          },
          '& .MuiDataGrid-row:hover': {
            backgroundColor: '#f8f9fa',
            cursor: 'pointer',
          },
        }}
      />
    </Box>
  )
}
